import React, { useEffect, useState } from "react";
import { Page, LoadingMsg } from "components/common";
import { XeroClient } from "services";
import { Button, Table } from 'reactstrap';
import { Trans, useTranslation } from "react-i18next";
import BackButton from "components/refactoring/BackButton";

const s = {
  td: {
    className: "text-left",
  },
  th: {
    className: "text-left",
    style: { fontSize: "1.3em" }
  },
  table: {
    className: "mt-4",
    style: {
      border: '1px solid #ccc',
      borderRadius: '5px',
      margin: '0 auto',
    }
  }
};

const getMethod = (unitPeriod) => {
  const matches = unitPeriod?.match(/^(\d+)([A-Z]+)$/);

  if (!matches) {
    return unitPeriod;
  }

  const period = parseInt(matches[1]);
  const unit = matches[2];

  if (period === 1) {
    return unit === "MONTHLY" ? "Month" : (unit === "WEEKLY" ? "Week" : unit);
  } else {
    return unit === "MONTHLY" ? `${period} Months` : (unit === "WEEKLY" ? `${period} Weeks` : unit);
  }
};

export const ExSpan = ({ label, value, reverse = false }) => (
  <td {...s.td}>
    {reverse ?
      <span><Trans>{label}</Trans><span className="d-flex text-muted">{value || "-"}</span></span>
      :
      <span><span className="d-flex text-muted"><Trans>{label}</Trans></span>{value || "-"}</span>
    }
  </td>
);

const TaxReturnsDetail = () => {
  const xero = XeroClient();
  const { t } = useTranslation();
  const [organisations, setOrg] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await xero.get("organisations");
        setOrg(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const reportLink = () => {
    window.location.href = `/reports/zatca`;
  };

  return (
    <Page className="inv-tabs nw-list">
      <BackButton />
      <div>
        {loading ? (
          <LoadingMsg />
        ) : (
          <div>
            <h4><Trans>Tax Returns Page</Trans></h4>
            {organisations?.map((i, index) => {
              let address = {}
              if(i.Addresses && i.Addresses.length > 0){
                const pos_box_address = i.Addresses?.findLast(i=>i.AddressType === 'POBOX')
                address = pos_box_address || i.Addresses[0]
              }
              return (
                <>
                  <Table {...s.table}>
                    <thead>
                      <tr>
                        <th {...s.th}><Trans>Taxpayer Details</Trans></th>
                        <th />
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      <tr key={index}>
                        <ExSpan label="Legal Company Name" value={i?.LegalName} />
                        <ExSpan label="Base Currency" value={i?.BaseCurrency} />
                        <ExSpan label="Short Code" value={i?.ShortCode} />
                      </tr>
                      <tr>
                        <ExSpan label="Tax Number" value={i?.TaxNumber} />
                        <ExSpan label="Registration Number" value={i?.RegistrationNumber} />
                        <ExSpan label="Tax Number Name" value={i?.TaxNumberName} />
                      </tr>
                      <tr>
                        <ExSpan label="Default Sales Tax" value={i?.DefaultSalesTax} />
                        <ExSpan label="Default Purchases Tax" value={i?.DefaultPurchasesTax} />
                        <td />
                      </tr>
                    </tbody>
                  </Table>
                  {i?.Addresses && i?.Addresses.length > 0 && (
                    <Table {...s.table}>
                      <thead>
                        <tr>
                          <th {...s.th}><Trans>Address Details</Trans></th>
                          <th />
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        <>
                          <tr key={index}>
                            <ExSpan label="Attention To" value={address.AttentionTo} />
                            <ExSpan label="Address Type" value={address.AddressType} />
                            <ExSpan label="Address Line" value={address.AddressLine1} />
                          </tr>
                          <tr>
                            <ExSpan label="City" value={address.City} />
                            <ExSpan label="Region" value={address.Region} />
                            <ExSpan label="Postal Code" value={address.PostalCode} />
                          </tr>
                          <tr>
                            <ExSpan label="Country" value={address.Country} />
                            <td />
                            <td />
                          </tr>
                        </>
                      </tbody>
                    </Table>
                  )}
                  <Table {...s.table}>
                    <thead>
                      <tr>
                        <th {...s.th}><Trans>Tax Return Details</Trans></th>
                        <th />
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        <tr key={index}>
                          <ExSpan label="Organisation Type" value={i?.OrganisationType} />
                          <ExSpan label="Return Reference Number" value={i?.RegistrationNumber} />
                          <ExSpan label="Sales Tax Period" value={getMethod(i?.SalesTaxPeriod)} />
                        </tr>
                        <tr>
                          <ExSpan label="Financial Year End Date" value={i?.FinancialYearEndDay} />
                          <ExSpan label="Financial Year End Month" value={i?.FinancialYearEndMonth} />
                          <ExSpan label="Sales Tax Basis" value={i?.SalesTaxBasis} />
                        </tr>
                      </>
                    </tbody>
                  </Table>
                </>
              )
            })}
            <div className="text-right my-3">
              <Button onClick={reportLink} color="primary"><Trans>Checkout VAT Details</Trans></Button>
            </div>
          </div>
        )}
      </div>
    </Page>
  );
};

export default TaxReturnsDetail;